import { useMemo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { CONTACT_EMAIL, VERIFF_CODES } from '@/helpers/constants';
import { useGetVeriffStatus } from '@/query/queries/user/useGetVeriffStatus';
import WarningBlock from '@/components/UI/WarningBlock';
import { useGetMe } from '@/hooks/useGetMe';
import s from './index.module.scss';

export const SuspendResidenceWarning = ({ className }) => {
  const { t } = useTranslation('warning');
  const { profile } = useGetMe();

  const { data: veriffStatus } = useGetVeriffStatus();

  const content = useMemo(() => {
    if (!profile || !veriffStatus) return null;

    if (veriffStatus?.code === VERIFF_CODES.customPassportDuplication) {
      return (
        <div className={classnames(s.text, 'f-16 f-400')}>
          {t('suspend_residence.passport_duplication')}
        </div>
      );
    }

    if (veriffStatus?.code === VERIFF_CODES.customPersonalDuplication) {
      return (
        <div className={classnames(s.text, 'f-16 f-400')}>
          {t('suspend_residence.profile_duplication')}
        </div>
      );
    }

    if (['RU', 'BY'].includes(profile?.country_code)) {
      return (
        <div className={classnames(s.text, 'f-16 f-400')}>
          <div>{t('suspend_residence.ru_by.message_1')}</div>
          <div>
            {t('suspend_residence.ru_by.message_2')}
            <MyLink href={APP_LINKS.email} underline isExternal>
              {CONTACT_EMAIL}
            </MyLink>
            {t('suspend_residence.ru_by.message_3')}
            <ul className="scr-circle-list">
              <li>{t('suspend_residence.ru_by.list_item_1')}</li>
              <li>{t('suspend_residence.ru_by.list_item_2')}</li>
              <li>{t('suspend_residence.ru_by.list_item_3')}</li>
            </ul>
          </div>
        </div>
      );
    }

    return (
      <div className={classnames(s.text, 'f-16 f-400')}>
        {t('suspend_residence.default.message')}{' '}
        <MyLink href={`mailto:${CONTACT_EMAIL}`} isExternal underline>
          {CONTACT_EMAIL}
        </MyLink>
      </div>
    );
  }, [profile, veriffStatus]);

  if (!content) return null;

  return (
    <WarningBlock withBorder className={classnames(s.wrapper, className)}>
      {content}
    </WarningBlock>
  );
};
